import { observable } from 'mobx';
import { MarketStore } from '.';
import { KLine, Tick, TickSpaceIndex } from '../canister/KLine';
import { IDisposable } from '../interface';

/**
 * Market Kline
 */
export class KLineStore implements IDisposable {
  @observable
  ticks: Array<Tick> = [];

  @observable
  tickSpaceIndex: TickSpaceIndex = TickSpaceIndex.FifteenMinutes;

  private marketStore: MarketStore;
  private klineActor: KLine;
  private timer?: NodeJS.Timer;
  private fetchTimeInterval: number = 10 * 1000;

  constructor(marketStore: MarketStore) {
    this.marketStore = marketStore;
    this.klineActor = new KLine(this.marketStore.marketSetting.klineCanisterId);
    this.tickSpaceIndex = TickSpaceIndex.FifteenMinutes;
    // this.fetchTicks();
    // this.startFetchTimer();
  }

  /**
   * switch the kline tick space
   * @param tickSpaceIndex
   */
  public switchTickSpace(tickSpaceIndex: TickSpaceIndex) {
    this.tickSpaceIndex = tickSpaceIndex;
    this.fetchTicks();
    this.restartFetchTimer();
  }

  private startFetchTimer() {
    this.timer = setInterval(this.updateTicks, this.fetchTimeInterval);
  }

  private stopFetchTimer = () => {
    if (this.timer) {
      clearInterval(this.timer);
      this.timer = undefined;
    }
  };

  private restartFetchTimer = () => {
    this.stopFetchTimer();
    this.startFetchTimer();
  };

  /**
   * Update ticks, fetch new ticks if needed
   */
  private updateTicks = async () => {
    if (this.ticks.length === 0) {
      this.ticks = await this.fetchTicks();
      return;
    }

    const currentTick = await this.fetchCurrentTick(this.tickSpaceIndex);

    if (currentTick) {
      // if the lask tick is the current tick, replace it
      if (
        this.ticks[this.ticks.length - 1].tickIndex === currentTick.tickIndex
      ) {
        console.debug(`replace tick ${currentTick.tickIndex}`, currentTick);
        this.ticks[this.ticks.length - 1] = currentTick;
      }
      // if the current tick is the next tick, add it to the end
      else if (
        this.ticks[this.ticks.length - 1].tickIndex ===
        currentTick.tickIndex - 1
      ) {
        console.debug(
          'KLine.updateTicks: current tick is the next tick ',
          currentTick
        );
        this.ticks.push(currentTick);
      }
      // maybe something wrong, reload the ticks
      else {
        console.warn(
          'KLine.updateTicks:maybe something wrong, reload the ticks'
        );
        this.ticks = await this.fetchTicks();
      }
    }
  };

  /**
   * fetch ticks
   * @returns  {Promise<Array<Tick>>}
   */
  private fetchTicks(): Promise<Array<Tick>> {
    const offset = 0;
    const limit = 1000;
    return this.klineActor.fetchTicks(this.tickSpaceIndex, offset, limit);
  }

  /**
   * get the current tick
   * @returns {Promise<Tick>}
   */
  public fetchCurrentTick(
    tickSpace: TickSpaceIndex
  ): Promise<Tick | undefined> {
    return this.klineActor.fetchCurrentTick(tickSpace);
  }
  /**
   * must be called before destroy
   */
  dispose = () => this.stopFetchTimer;
}
